import {filter, unionBy, isEmpty} from 'lodash';
import fp from 'lodash/fp';
import req from 'shared/req';
import {PascalInstitutionType} from 'src/types/enums';

const subtextFields = ['street_address', 'city', 'state'];
const formatSchoolSubtext = fp.flow(fp.at(subtextFields), fp.compact, fp.join(', '));

const transformCollegeResults = (query, initialResults, results) => {
  const normalized = query.toLowerCase();
  const yourSchools = filter(
    initialResults,
    (result) => result.text.toLowerCase().indexOf(normalized) >= 0
  );

  const moreSchools = results.map((result) => {
    const fields = result.fields;
    const campuses =
      fields.campuses && !isEmpty(fields.campuses) ? JSON.parse(fields.campuses) : [];
    const isCommunityCollege = fields.community_college === 'true';

    return {
      _id: result.id,
      text: fields.name,
      ncesId: fields.nces_id,
      directoryInfoId: fields.directory_info_id,
      subtext: formatSchoolSubtext(fields),
      campuses,
      communityCollege: isCommunityCollege,
      parentId: isCommunityCollege ? fields.nces_id : result.id,
      educationPhase: isCommunityCollege
        ? PascalInstitutionType.COMMUNITY_COLLEGE
        : PascalInstitutionType.UNDERGRADUATE,
    };
  });

  return unionBy(yourSchools, moreSchools, '_id');
};

export async function collegeQueryResults(
  query,
  initialResults = [],
  communityCollege = false,
  loc,
  state = ''
) {
  const data = {q: query};

  if (communityCollege) {
    data['community-college'] = true;
  }

  if (loc) {
    data['lat'] = loc[0];
    data['long'] = loc[1];
  }

  if (state) {
    data['state'] = state;
  }

  return req({
    url: '/v1/nearest-colleges',
    method: 'get',
    data,
  }).then((results) => transformCollegeResults(query, initialResults, results));
}
